import { BezeichnungListEntry } from './BezeichnungListEntry';
import { BezeichnungTableCell } from './BezeichnungTableCell';

const BezeichnungEntry = {
    List: BezeichnungListEntry,
    Cell: BezeichnungTableCell,
};

export { BezeichnungEntry };
